

const Operators: string[] = ["=", "!=", ">", ">=", "<", "<="];

export default Operators;